import template from '../../templates/Home/nav.template';
import Component from '../../core/component';

export default class Nav extends Component {
    constructor(data) {
        super(template, data);
    }
}
